export default __webpack_public_path__ + "static/media/WorkSans-Bold.c25757b7.ttf";